import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import YoybuySpreadsheetGuide from "@/pages/articles/yoybuy-spreadsheet-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/articles/yoybuy-spreadsheet-guide",
    element: <YoybuySpreadsheetGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;